export class Modal
{
    constructor(html, closeButton=false, addClass='')
    {
        this.scrollY = window.scrollY;
        if(typeof HTMLDialogElement === 'function')
        {
            this.native = true;
            this.dialog = document.createElement('dialog');
            this.dialog.classList.add('w__modal');
            document.body.appendChild(this.dialog);
            this.dialog.showModal();
            window.scrollTo(0, this.scrollY);
        }
        else
        {
            document.body.classList.add('mod--blur');
            this.native = false;
            this.dialogContainer = document.createElement('div');
            this.dialogContainer.classList.add('w__modal--container');
            // noinspection JSValidateTypes
            this.dialog = document.createElement('div');
            this.dialog.classList.add('w__modal');
            this.dialogContainer.appendChild(this.dialog);
            document.body.appendChild(this.dialogContainer);
            this.dialog.offsetHeight;
        }

        if(closeButton === true)
        {
            const closeDiv = document.createElement('p');
            closeDiv.classList.add('w__modal--close-div');

            const close = document.createElement('button');
            close.classList.add('w__button');
            close.classList.add('w__modal--close');
            close.alt = 'Close';
            close.addEventListener('click',() =>
            {
                document.body.classList.remove('mod--modal');
                setTimeout(() => { this.remove(); },500);
            });

            closeDiv.appendChild(close);
            this.dialog.classList.add('mod--close');
            this.dialog.appendChild(closeDiv);
        }

        this.add_textElement(html);

        if(addClass)
        {
            this.dialog.classList.add(addClass);
        }

        document.body.classList.add('mod--modal');
    }

    add_textElement(html, clear=false)
    {
        if(this.dialog && html)
        {
            if(clear === true)
            {
                this.dialog.innerHTML = '';
            }

            const div = document.createElement('div');
            div.classList.add('w__modal--text');
            div.innerHTML = html;
            this.dialog.appendChild(div);
            return div;
        }
    }

    remove()
    {
        if(this.dialog)
        {
            if(this.native === true)
            {
                this.dialog.close();
                this.dialog.remove();
            }
            else
            {
                document.body.classList.remove('mod--blur');
                this.dialogContainer.remove();
            }
            window.scrollTo(0, this.scrollY);
            sessionStorage.setItem('hide-newsletter', '1');
        }
    }
}
